module.exports = __webpack_public_path__ + "static/media/finance.00ba468d.png";